import {BaseApiService} from "../../../StarterKit/Service/BaseApiService";

export default class ApiKpi extends BaseApiService {
    async getKPIReport(page,query) {
        this.setGetMethod();
        this.setSecureByService();
        this.setApiRoute(sessionStorage['language'] + `${page}?${query}`);
        return await this.callApi();
    }
}